import React from 'react';
import { SearchBar } from '@sections/shared/SearchBar';
import { StyledNavWrapper, StyledSection, StyledText, StyledWrapper } from './RegistryTopBarSection.styles';
import { ReactComponent as SearchIcon } from '@sections/shared/SearchBar/search.svg';
import { CTALink } from '@components/CTALink';
import { useTranslation } from 'react-i18next';

export const RegistryTopBarSection = () => {
  const { t } = useTranslation('registry');

  return (
    <StyledSection as="section" id="Registry_Topbar_Section">
      <StyledWrapper>
        <SearchBar
          submitLabel={<SearchIcon css={{ fill: 'white' }} />}
          placeHolder={t('shopSearch.placeHolder')}
          eventName="RegistrySearched"
          variant="secondary"
          id="registry"
          enabledAmplitude={true}
        />
        <StyledNavWrapper as="nav">
          {t('shopCategories').map((item) => (
            <CTALink key={item.name} id={item.name} variant="primary" href={item.link}>
              <StyledText tagName="p" variant="featureCopy17">
                {item.name}
              </StyledText>
            </CTALink>
          ))}
        </StyledNavWrapper>
      </StyledWrapper>
    </StyledSection>
  );
};
